module.exports = __webpack_public_path__ + "static/img/8areaA_08.39092ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/8areaA_08.png
// module id = 970
// module chunks = 1